import { useMemo } from 'react';

import { useUserIsConfirmed, useUserIsSelfService } from '@hcs/auth';
import { combineUseQueryResult } from '@hcs/utils';

import { useSelfServicePaymentMethod } from './useSelfServicePaymentMethod';

export const useUserSelfServiceConfirmed = (config?: {
  checkPaymentIntent: boolean;
}) => {
  const userIsConfirmedQuery = useUserIsConfirmed();
  const userIsSelfServiceQuery = useUserIsSelfService();
  const selfServicePaymentMethodQuery = useSelfServicePaymentMethod({
    enabled: !!config?.checkPaymentIntent,
  });
  const combinedQuery = combineUseQueryResult(
    config?.checkPaymentIntent
      ? [
          userIsConfirmedQuery,
          userIsSelfServiceQuery,
          selfServicePaymentMethodQuery,
        ]
      : [userIsConfirmedQuery, userIsSelfServiceQuery]
  );

  const isSelfServiceAndConfirmed = useMemo(() => {
    if (combinedQuery.isSuccess) {
      const { data: userIsConfirmed } = userIsConfirmedQuery;
      const { data: userIsSelfService } = userIsSelfServiceQuery;
      const { data: userHasPaymentIntent } = selfServicePaymentMethodQuery;
      if (combinedQuery.isSuccess) {
        return config?.checkPaymentIntent
          ? userIsConfirmed && userIsSelfService && userHasPaymentIntent
          : userIsConfirmed && userIsSelfService;
      }
    }
    return undefined;
  }, [
    userIsConfirmedQuery,
    userIsSelfServiceQuery,
    combinedQuery.isSuccess,
    selfServicePaymentMethodQuery,
    config?.checkPaymentIntent,
  ]);

  return {
    ...combinedQuery,
    data: isSelfServiceAndConfirmed,
  };
};
